/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard from './components/vx-card/VxCard.vue'
import VxList from './components/vx-list/VxList.vue'
import VxBreadcrumb from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon from './components/FeatherIcon.vue'
import VxInputGroup from './components/vx-input-group/VxInputGroup.vue'
import DatePicker from "./components/date-picker/DatePicker.vue";
import BusinessCategorySelect from "./views/bpay/components/BusinessCategorySelect.vue"
import SelectAccount from "./views/bpay/components/SelectAccount.vue"
import VueTippy, { TippyComponent } from "vue-tippy";
import moment from "moment-jalaali";
import PrettyInput from 'pretty-checkbox-vue/input';
import PrettyCheck from 'pretty-checkbox-vue/check';
import PrettyRadio from 'pretty-checkbox-vue/radio';
import excel from "vue-json-excel";



Vue.prototype.$moment = moment;

Vue.use(VueTippy);

Vue.component(SelectAccount.name, SelectAccount)
Vue.component(BusinessCategorySelect.name, BusinessCategorySelect)
Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component("date-picker", DatePicker)
Vue.component("tippy", TippyComponent)
Vue.component("export-excel", excel)

//pretty-checkbox
Vue.component('p-input', PrettyInput);
Vue.component('p-check', PrettyCheck);
Vue.component('p-radio', PrettyRadio);

//paginate
import Paginate from "vuejs-paginate";
Paginate.props.marginPages.default = 3;
Paginate.props.pageRange.default = 10;
Paginate.props.prevText.default = "قبلی";
Paginate.props.nextText.default = "بعدی";
Paginate.props.prevClass.default = "prev";
Paginate.props.nextClass.default = "next";
Paginate.props.containerClass.default = "paginate";
Vue.component("paginate", Paginate)


// v-select component
import vSelect from 'vue-select'
// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    }),
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    }),
  },
});
Vue.component('v-select', vSelect)

Vue.options.components.VsTable.options.props.noDataText.default = 'داده‌ای وجود ندارد';
Vue.options.components.VsTable.mixin({
  updated() {
    const E_C_COL = "e-c-col";
    if (!this.$el.classList.contains('responsable-table')) return;

    let ths = [];
    if (this.$refs["table"].children[0].tagName == 'THEAD' && this.$refs["table"].children[0].rows[0]) {
      ths = this.$refs["table"].children[0].rows[0].cells;
    }

    let trs = this.$refs["table"].children;
    trs.forEach(tr => {
      if (tr.tagName == "TR") {
        tr.children.forEach((td, i) => {
          if (!td.getAttribute('title') && ths[i])
            td.setAttribute('title', ths[i].innerText);
        });
        let td = document.createElement("td");
        td.className = E_C_COL;
        td.onclick = () => {
          tr.getElementsByClassName("e-col").forEach(x => {
            x.classList.toggle("e-col-active");
          });
          tr.getElementsByClassName(E_C_COL)[0].classList.toggle(
            "e-c-col-active"
          );
        };
        if (tr.getElementsByClassName(E_C_COL).length == 0) tr.append(td);
      }
    });

  }
});
Vue.options.components.VsTr.mixin({
  mounted() {
    this.$el.addEventListener("dblclick", (e) => {
      if (e.ctrlKey) {
        this.$helper.copy(JSON.stringify(this.data, null, 4), "رکورد کپی شد")
      } else if(e.shiftKey) {
        this.$helper.copy(this.$options._parentVnode.key, "ID کپی شد")
      }
    });
  }
});

Vue.options.components.VsInput.mixin({
  mounted() {
    let btnClose = document.createElement("span");
    btnClose.className = `btn-close`;
    btnClose.addEventListener("click", () => {
      this.value = '';
    });
    btnClose.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 mt-1">
    <line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>`;
    this.$el.children[0].append(btnClose);
  },
  methods: {
    focus() {
      this.$el.children[0].children[0].focus();
    }
  }
});

// Register a global custom directive called v-focus
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.children[0].children[0].focus();
  }
});

// Vue.config.optionMergeStrategies.mounted = function mergeHook(
//   parentVal,
//   childVal
// ) {
//   var res = childVal
//     ? parentVal
//       ? parentVal.concat(childVal)
//       : Array.isArray(childVal)
//         ? childVal
//         : [childVal]
//     : parentVal;
//   return res
//     ? dedupeHooks(res)
//     : res
// }
// function dedupeHooks(hooks) {
//   var res = [];
//   if (hooks.length > 0) {
//     res.push(hooks[hooks.length - 1]);
//   }
//   return res
// }


// Vue.options.components.VsPagination.mixin({
// });

// import VueContext from "vue-context-menu";
// VueContext.watch = {
//   ctxVisible: {
//     handler: function (p1, p2) {
//       const handleScroll= ()=> {
//         this.ctxVisible=false;
//       }
//       if (p1)
//         window.addEventListener('scroll', handleScroll);
//       else
//         window.removeEventListener('scroll', handleScroll);
//     }
//   }
// }
// Vue.component('vue-context2', VueContext);
